export default "__VITE_ASSET__DCwBbBCc__"